import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import JobOrderDrawer from "../om/job/modules/JobOrderDrawer";
import { formatDate } from '@/utils/util';
export default {
  name: 'St21WarnList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    JobOrderDrawer: JobOrderDrawer
  },
  data: function data() {
    return {
      autoLoadInit: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      isorter: {
        column: 'warn_time',
        order: 'desc'
      },
      pagePath: '/online/warn',
      pageTitle: '设备报警',
      // 表头
      columns: [{
        dataIndex: 'warnTime',
        colName: 'warn_time',
        title: '报警时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorName',
        colName: 'factor_name',
        title: '因子名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorVal',
        colName: 'factor_val',
        title: '监测数值',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnContent',
        colName: 'warn_content',
        title: '报警内容',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnStatus_dictText',
        colName: 'warn_status',
        title: '报警状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkTime',
        colName: 'check_time',
        title: '确认时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkUserName',
        colName: 'check_user',
        title: '确认人',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 240,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        checkBatch: '/online/warn/checkBatch',
        delete: '/online/warn/deleteBatch'
      }
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();

      if (window.sessionStorage.getItem('siteType')) {
        this.getCol(window.sessionStorage.getItem('siteType'));
      }
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          res.result.records.forEach(function (item, index) {
            item = _objectSpread(_objectSpread({}, item.children[0]), item);
            item.warnContent = item.children[0].warnContent;
            delete item.children;
            res.result.records[index] = item;
            console.log('item', item);
          });
          _this.dataSource = res.result.records;
          console.log('dataSource', _this.dataSource);
          _this.ipagination.total = res.result.total;
          _this.loadNums++;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    loadData: function loadData(arg) {
      this.queryParam.category = '2'; //this.queryParam.st = window.sessionStorage.getItem('siteType')

      this.initTableData(arg);
    },
    onDateWarnTime: function onDateWarnTime(value, dateArray) {
      this.queryParam.stime = dateArray[0];
      this.queryParam.etime = dateArray[1];
    },
    handleWarn: function handleWarn(record) {
      var param = {};
      param.siteId = record.siteId;
      param.originKey = '2';
      param.originId = record.id;
      var content = record.warnContent + ';';
      content = content + record.factorName + record.warnContent + ';';
      var title = formatDate(record.warnTime, 'yyyy-MM-dd');
      title += record.factorName + record.errorCode_dictText;
      param.remark = content; //param.category = record.category

      param.title = title + record.warnContent;
      this.$refs.modalForm.edit(param);
      this.$refs.modalForm.title = '生成工单';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleCheck: function handleCheck(record) {
      var ids = record.id;
      var that = this;
      this.$confirm({
        title: '确认',
        content: '是否确认选中数据?',
        onOk: function onOk() {
          getAction(that.url.checkBatch, {
            ids: ids
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    batchCheck: function batchCheck() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认',
          content: '是否确认选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            getAction(that.url.checkBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};